var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('toggle-button',{attrs:{"color":_vm.color,"labels":_vm.getLabels,"font-size":15,"width":220,"height":40},on:{"change":_vm.emitConfig},model:{value:(_vm.config.amountView),callback:function ($$v) {_vm.$set(_vm.config, "amountView", $$v)},expression:"config.amountView"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }